var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0109 20.8599C6.59227 20.8599 2.1806 16.4482 2.1806 11.0296C2.1806 5.61089 6.59227 1.19922 12.0109 1.19922C17.4296 1.19922 21.8413 5.61089 21.8413 11.0296C21.8413 16.4482 17.4296 20.8599 12.0109 20.8599ZM12.0109 2.63781C7.3787 2.63781 3.61919 6.4069 3.61919 11.0296C3.61919 15.6522 7.3787 19.4213 12.0109 19.4213C16.6432 19.4213 20.4027 15.6522 20.4027 11.0296C20.4027 6.4069 16.6432 2.63781 12.0109 2.63781Z",
    fill: "#362B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0807 21.8187C21.8985 21.8187 21.7162 21.7515 21.5724 21.6077L19.6543 19.6896C19.3761 19.4114 19.3761 18.9511 19.6543 18.673C19.9324 18.3948 20.3927 18.3948 20.6709 18.673L22.589 20.5911C22.8671 20.8692 22.8671 21.3295 22.589 21.6077C22.4451 21.7515 22.2629 21.8187 22.0807 21.8187Z",
    fill: "#362B24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.80fadb2e51e4498a92871cca685ba2d3.svg";
export { ForwardRef as ReactComponent };